import firebase from 'firebase';
// Initialize Firebase
const firebaseConfig = {
  apiKey: "AIzaSyC6PsmSMSnwgljnMEpzCaVRCTR-oQgT7T4",
  authDomain: "fun-eat-produccion.firebaseapp.com",
  databaseURL: "https://fun-eat-produccion.firebaseio.com",
  projectId: "fun-eat-produccion",
  storageBucket: "fun-eat-produccion.appspot.com",
  messagingSenderId: "199593138345",
  appId: "1:199593138345:web:ceacb4a244a43512c4b1b8",
  measurementId: "G-KK3M8BGV0R"
};

firebase.initializeApp(firebaseConfig);
//firebase.analytics();
if (process.env.NODE_ENV === 'development') {
  firebase.functions().useFunctionsEmulator('http://localhost:5000')
} else {

}
const projectId = "fun-eat-produccion";

const db = firebase.firestore();
const functions = firebase.functions();
const storage = firebase.storage();

const auth = firebase.auth();
export { db, functions, storage, projectId, auth, firebase }
